import {
  GET_USER_GROUPS,
  CREATE_USER_GROUPS,
  UPDATE_USER_GROUP,
  DELETE_USER_GROUP,
  UNLINK_USER_FROM_GROUP,
  GET_EXISTING_MANAGER_USERS,
  LINK_EXISTING_USER_TO_GROUP
} from './actionTypes';
import { getActionStatusName } from '@/store/helpers';

export const getUserGroupsStatus = state => state.status[getActionStatusName(GET_USER_GROUPS)] || {};
export const createGroupStatus = state => state.status[getActionStatusName(CREATE_USER_GROUPS)] || {};
export const updateGroupStatus = state => state.status[getActionStatusName(UPDATE_USER_GROUP)] || {};
export const deleteGroupStatus = state => state.status[getActionStatusName(DELETE_USER_GROUP)] || {};
export const unlinkUserStatus = state => state.status[getActionStatusName(UNLINK_USER_FROM_GROUP)] || {};
export const getExistingManagerUsersStatus = state => state.status[getActionStatusName(GET_EXISTING_MANAGER_USERS)] || {};
export const linkExistingUserStatus = state => state.status[getActionStatusName(LINK_EXISTING_USER_TO_GROUP)] || {};

export const existingBuyerManagerUsers = state => state.existingAccountUsers.filter(u => u.role === 'buyer_manager');
export const existingPubManagerUsers = state => state.existingAccountUsers.filter(u => u.role === 'affiliate_manager');
